import React,{useState} from 'react';
import { Box } from '@mui/system';
import HeroBanner from '../component/HeroBanner';
import SearchExercises from '../component/SearchExercises';
import Exercises from '../component/Exercises';
const Home = () => {
  // Changes in these state are going to be reflected all over the application thats why we put in HOME page
  const [bodyPart,setBodyPart]=useState('all')
  const [exercises,setExercises]=useState([]);
console.log(bodyPart)
  return (
    <Box>
    
        <HeroBanner/>
        <SearchExercises 
        setExercises={setExercises}
        bodyPart={bodyPart}
        setBodyPart={setBodyPart}
        />
        <Exercises
        exercises={exercises}
             setExercises={setExercises}
             bodyPart={bodyPart}
             />
             </Box>
  )
}

export default Home